import { Routes } from '@angular/router';
import { SiteAppComponent } from './site-app.component';

export const routes: Routes = [
  {
    path: 'raw-image',
    loadComponent: () => import('./image/images/raw-image-wrapper.component').then((c) => c.RawImageWrapperComponent),
    loadChildren: () => import('./image/images/routes'),
  },
  {
    path: '',
    component: SiteAppComponent,
    children: [
      { path: '', loadChildren: () => import('./main/routes') },
      { path: 'meets', loadChildren: () => import('./meet/routes') },
      {
        path: 'image',
        loadComponent: () =>
          import('./image/controller/image-controller.component').then((c) => c.ImageControllerComponent),
        loadChildren: () => import('./image/controller/routes'),
      },
      { path: 'athletic-sb-controller', loadChildren: () => import('./athletic-sb/routes') },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'meet-list',
      },
    ],
  },
];
